import Api from "./api";

class GuideService {
    api = new Api();

    getCategories() {
        return this.api.get('/admin/guide/get-super-groups');
    }
    getCategoryContent(id) {
        return this.api.get('/admin/guide/get-category-content', {
            id: id
        })
    }
}

export default new GuideService();

